module.exports = __webpack_public_path__ + "static/media/I DON'T LOVE YOU ANYMORE.f6687386.mp3";